<template>
	<div class="player-wrapper">

		<iframe
			:src="iframeSource"
			width="600"
			height="500"
			referrerpolicy="same-origin"
			scrolling="no"
		/>
	</div>
</template>

<script>
export default {
	props: {
		targetScore: {
			type: String,
			required: true,
		}
	},
	computed: {
		iframeSource() {
			const scoreID = this.$route.query.scoreID;
			return '/danoni-sources/danoni/' + this.targetScore + '.html?scoreId=' + scoreID;
		}
	}

}
</script>

<style scoped>
	.player-wrapper {
		width: 100%;
		text-align: center;
	}

	iframe {
		border: 0;
		
	}
</style>